import { useEffect, useState } from "react";
import "../../Css/NewHome/NewCommunity.css";
import demoimage from "../../Images/image.webp";
import { NavLink } from "react-router-dom";
import { get } from "../../services/ApiRouting";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";

const NewCommunity = () => {
  const [community, setCommunity] = useState([]);
  const fetchData = async () => {
    const response = await get("communities?type=cast");
    setCommunity(response.data);
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  return (
    <section className="new-home-community-section section">
      <div className="container">
        <div className="new-home-community-main-con">
          <div className="all-page-common-head-main-section">
            <div className="head-common-image-con">
              <img src={demoimage} />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <div className="all-page-common-tag-para-main-con">
                <h3 className="text-center">
                  "Everything You Need for the Perfect Day — In One Platform."
                </h3>
                <p className="text-center">
                  Plan, organize, and celebrate your dream wedding effortlessly
                  in one place.
                </p>
              </div>
            </div>
          </div>
          <div className="new-home-community-details-main-con">
            <div className="row">
              <div className="col-md-4">
                <div className="new-home-community-image-main-div">
                  <NavLink to={`/vendors?cast=${community[0]?.id}`}>
                    <div className="new-home-community-image-main-con">
                      <div className="new-home-community-image-con">
                        <img
                          src={community[0]?.image || venues_demo_image}
                          alt={community[0]?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = venues_demo_image;
                          }}
                        />
                      </div>

                      <div className="new-home-community-text-main-con">
                        <h3>{community[0]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                  <NavLink to={`/vendors?cast=${community[1]?.slug}`}>
                    <div className="new-home-community-image-main-con">
                      <div className="new-home-community-image-con">
                        <img
                          src={community[1]?.image || venues_demo_image}
                          alt={community[1]?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = venues_demo_image;
                          }}
                        />
                      </div>

                      <div className="new-home-community-text-main-con">
                        <h3>{community[1]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
              <div className="col-md-4">
                <div className="new-home-community-mid-image-main-con">
                  <NavLink to={`/vendors?cast=${community[2]?.slug}`}>
                    <div className="new-home-community-image-main-con">
                      <div className="new-home-community-mid-image-con">
                        <img
                          src={community[2]?.image || venues_demo_image}
                          alt={community[2]?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = venues_demo_image;
                          }}
                        />
                      </div>

                      <div className="new-home-community-text-main-con">
                        <h3>{community[2]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
              <div className="col-md-4">
                <div className="new-home-community-image-main-div">
                  <NavLink to={`/vendors?cast=${community[3]?.slug}`}>
                    <div className="new-home-community-image-main-con">
                      <div className="new-home-community-image-con">
                        <img
                          src={community[3]?.image || venues_demo_image}
                          alt={community[3]?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = venues_demo_image;
                          }}
                        />
                      </div>

                      <div className="new-home-community-text-main-con">
                        <h3>{community[3]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                  <NavLink to={`/vendors?cast=${community[4]?.slug}`}>
                    <div className="new-home-community-image-main-con">
                      <div className="new-home-community-image-con">
                        <img
                          src={community[4]?.image || venues_demo_image}
                          alt={community[4]?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = venues_demo_image;
                          }}
                        />
                      </div>

                      <div className="new-home-community-text-main-con">
                        <h3>{community[4]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewCommunity;
